import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { defaultColor } from './default';
import { errorColor } from './error';
import { infoColor } from './info';
import { newColor } from './new';
import { successColor } from './success';
import { warningColor } from './warning';

export const status = (mode: PaletteMode, opts: GetThemeOptions) => {
  return {
    default: defaultColor(mode, opts),
    new: newColor(mode, opts),
    info: infoColor(mode, opts),
    success: successColor(mode, opts),
    warning: warningColor(mode, opts),
    error: errorColor(mode, opts),
  };
};
